import axios from 'axios';
import { GATEWAY_URL } from '../utils/constants';

// Instância pública sem interceptors de auth — rota pública, sem token necessário
const publicClient = axios.create({ baseURL: GATEWAY_URL });

export async function getIncomeTaxDocument(cpf, hash) {
  const { data } = await publicClient.get(`media/incomeTax/document/${cpf}/${hash}`);
  return data;
}
